module.exports = __webpack_public_path__ + "/images/93c4591cbc6700e8ea324a0b377acc19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/description.png
// module id = 795
// module chunks = 0